export const faqButton = "FAQ"
export const termsOfUseButton = 'Terms of Use';